import { ActionTree, Store } from "vuex";
import { ActivityState } from "./types";
import { IRootState, IRootGetters } from "../types";
import { mutationNames } from "./mutations";
import { buildAction } from "../utils";
import { getActivities } from "@dcc/lookup/activities/activities";
import { Gender } from "@dcc/types/gender";

export const actionNames = {
  TOGGLEACTIVITY: "ToggleActivity",
  FETCHACTIVITIES: "FetchActivities"
};

export const actions: ActionTree<ActivityState, IRootState> = {
  [actionNames.TOGGLEACTIVITY]({ commit }, id: number) {
    commit(mutationNames.TOGGLEACTIVITY, id);
  },
  async [actionNames.FETCHACTIVITIES](
    {
      commit,
      state,
      rootGetters
    }: {
      commit: any;
      state: ActivityState;
      rootGetters: IRootGetters;
    },
    {
      numDrinkingDaysInput,
      genderInput
    }: {
      numDrinkingDaysInput?: number;
      genderInput?: number;
    } = {
      numDrinkingDaysInput: undefined,
      genderInput: undefined
    }
  ) {
    let numDrinkingDays: number;
    let gender: Gender | undefined;
    if (genderInput === undefined || !numDrinkingDaysInput) {
      numDrinkingDays = rootGetters["drinking/drinksOnADay"]
        ? rootGetters["drinking/drinksOnADay"].length
        : 0;
      gender = rootGetters["profile/gender"];
    } else {
      numDrinkingDays = numDrinkingDaysInput;
      gender = genderInput as Gender;
    }

    if (gender !== undefined && numDrinkingDays > 0) {
      const activites = await getActivities(gender, numDrinkingDays);
      commit(mutationNames.FETCHACTIVITIES, activites);
    }
  }
};

export const getActions = (store: Store<IRootState>) => ({
  toggleActivity: buildAction<number>(
    store,
    "activity",
    actionNames.TOGGLEACTIVITY
  ),
  fetchActivities: buildAction<{
    numDrinkingDaysInput?: number;
    genderInput?: number;
  } | void>(store, "activity", actionNames.FETCHACTIVITIES)
});
